export default __webpack_public_path__ + "static/media/logor.c94e13e0.svg";